import styled from "styled-components";

import * as Styles from "@/utils/styles";

// ============== //
// ↓↓↓ Skills ↓↓↓ //
// ============== //

export const Skills = styled("section")`
	${Styles.Snippets.grid(1, "1fr", 20)};
`;
